import React from 'react';
import Hero from './components/Hero';
import TrustedBy from './components/TrustedBy';
import Features from './components/Features';
import BusinessFeatures from './components/BusinessFeatures';
import Testimonial from './components/Testimonial';
//import PricingPlans from './components/PricingPlans';
//import AddOns from './components/AddOns';
import FAQ from './components/FAQ';
import ContactCTA from './components/ContactCTA';
import SEO from './components/SEO';
import { CreditCard, BarChart2, Gift, Coins } from 'lucide-react';
import './App.css';

const features = [
  {
    icon: "",
    title: "Effortless Setup",
    description: "Install and start using VernPOS in minutes with zero hassle.",
    bgColor: "bg-[#F8E8E7] border-[#F8C9D2] border-2",
    image: "/images/pos-device-small.png"
  },
  {
    icon: <Coins size={32} className="text-gray-800" />,
    title: "Scalable for Growth",
    description: "Expand your business with a POS that grows with you.",
    bgColor: "bg-gray-100 border-gray border-2",
  },
  {
    icon: <CreditCard size={32} className="text-gray-800" />,
    title: "Integrated Payments",
    description: "Accept cards & mobile wallets",
    bgColor: "bg-gray-100 border-gray border-2"
  },
  {
    icon: <Gift size={32} className="text-gray-800" />,
    title: "Loyalty Programs",
    description: "Engage customers with rewards and discounts.",
    bgColor: "bg-gray-100 border-gray border-2"
  },
  {
    icon: <BarChart2 size={32} className="text-gray-800" />,
    title: "Analytics & Reporting",
    description: "Get sales and customer insights in real-time.",
    bgColor: "bg-gray-100 border-gray border-2"
  }
];

const faqs = [
  {
    question: "What types of businesses can benefit from your kiosk solutions?",
    answer: "Our kiosk solutions are designed for a wide range of businesses including restaurants, cafes, retail stores, and service-based businesses. Whether you're a small food stall or a multi-location restaurant chain, our solutions can be tailored to your needs."
  },
  {
    question: "Can the kiosk support multiple payment options?",
    answer: "Yes, our kiosk solutions support various payment methods including credit/debit cards, mobile wallets like Apple Pay and Google Pay, and QR code payments."
  },
  {
    question: "Is it possible to customize the interface and menu for my business?",
    answer: "Absolutely! Our kiosk interface is fully customizable to match your brand identity and menu structure. You can easily update menu items, prices, and promotions through our intuitive admin dashboard."
  },
  {
    question: "Can the kiosk system integrate with my existing POS and software?",
    answer: "Yes, our kiosk system is designed to integrate seamlessly with most popular POS systems and business software. Our team can provide integration support for your specific setup."
  },
  {
    question: "How does the kiosk handle inventory management?",
    answer: "Our kiosk system includes real-time inventory tracking that automatically updates when items are sold. You can set low-stock alerts and view comprehensive inventory reports to help manage your stock efficiently."
  },
  {
    question: "What kind of support do you offer for kiosk installations and maintenance?",
    answer: "We provide full installation support and training for your staff. Additionally, we offer ongoing technical support and regular software updates to ensure your kiosk runs smoothly."
  }
];

function App() {
  return (
    <div className="app">
      <SEO 
        title="Cloud POS System Malaysia | Retail, F&B, Salon | VernPOS"
        description="VernPOS is Malaysia's leading cloud POS system for F&B, retail, & salons. Streamline operations, manage inventory, & boost sales. Get a free demo today!"
        keywords="POS Malaysia, cloud POS system, retail POS Malaysia, F&B POS, salon POS, restaurant POS Malaysia, kedai POS system, sistem POS, inventory management"
      />
      <Hero />
      <TrustedBy />
      <Features
        features={features}
        heading="Unlock the Full Potential of Your Business"
        subheading="Discover how VernPOS can drive efficiency, reduce costs, and grow your bottom line."
      />
      <BusinessFeatures />
      <Testimonial />
      {/* <PricingPlans />
      <AddOns /> */}
      <FAQ
        title="Frequently Asked Questions"
        faqs={faqs}
      />
      <div className="max-w-6xl mx-auto px-4 py-8">
        <ContactCTA />
      </div>
    </div>
  );
}

export default App;